/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Orders.css";
import Sidebar from "../../../components/worker/sidebar/SidebarWorker";
import Navbar from "../../../components/worker/navbar/Navbar2";
import Footer from "../../../components/worker/footer/Footer";
import DataTableTemplatingDemoAbndn from "../../../components/worker/orders/DataTableTemplatingDemo/DataTableTemplatingDemoAbndn";
import { useTranslation } from "react-i18next";
import { collection, getDocs, query, Timestamp, where } from "firebase/firestore";
import {
  ShoppingBag,
  Search,
  Package,
  ShoppingCart,
  ShoppingBasket,
  RefreshCw,
} from "lucide-react";
import { db } from "../../../firebase";
import { fetchOrders as fetchOrdersAction } from "../../../redux/orders/orders";

function WorkerOrdersabndn() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const data = useSelector((state) => state.OrdersReducer);
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);

  const [showSideBar, setShowSideBar] = useState(true);
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [pageSize, setPageSize] = useState(10);
  const [isPageSizeOpen, setIsPageSizeOpen] = useState(false);
  const [isRefreshingOrders, setIsRefreshingOrders] = useState(false);
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("");
  const [filter2, setFilter2] = useState("0");
  const [AllOrders, setAllOrders] = useState("0");
  const [AllOrders20, setAllOrders20] = useState("0");

  const pageSizeOptions = [
    { value: 5, label: t("orders.five_orders") },
    { value: 10, label: t("orders.ten_orders") },
    { value: 25, label: t("orders.twenty_five_orders") },
    { value: 50, label: t("orders.fifty_orders") },
    { value: 100, label: t("orders.onehandred_orders") },
  ];

  const handlePageSizeSelect = (value) => {
    setPageSize(value);
    setIsPageSizeOpen(false);
  };

  const handleRefreshOrders = () => {
    if (!account?.user || isRefreshingOrders) return;

    const refresh = async () => {
      setIsRefreshingOrders(true);
      try {
        const nowTimestamp = Timestamp.fromDate(new Date());
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        const oneWeekAgoTimestamp = Timestamp.fromDate(oneWeekAgo);

        const snapshot = await getDocs(
          query(
            collection(db, "orders"),
            where("user", "==", account.user),
            where("timeStamp", "<", nowTimestamp),
            where("timeStamp", ">", oneWeekAgoTimestamp)
          )
        );

        const ordersList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const filteredOrders = ordersList.filter((order) => order.deleted !== 1);

        dispatch(
          fetchOrdersAction(
            filteredOrders
              .sort((a, b) => b.timeStamp.seconds - a.timeStamp.seconds)
              .map((item, index) => ({
                ...item,
                index: filteredOrders.length - index + 999,
              }))
          )
        );
      } catch (error) {
        console.error("Error refreshing worker abandoned orders:", error);
      } finally {
        setIsRefreshingOrders(false);
      }
    };

    refresh();
  };

  useEffect(() => {
    if (!data) return;

    let filteredOrders = [];
    let countAll = 0;
    let countFiltered = 0;

    const ordersByPhoneAndDay = {};
    const countOrdersperDay = {};
    const IdOrdersperDay = {};

    data.forEach((order) => {
      const date = new Date(order.timeStamp.seconds * 1000).toDateString();
      const key = `${order.phone}-${date}`;

      if (!ordersByPhoneAndDay[key]) {
        ordersByPhoneAndDay[key] = [];
      }
      ordersByPhoneAndDay[key].push(order);

      countOrdersperDay[key] = (countOrdersperDay[key] || 0) + 1;

      if (!IdOrdersperDay[key]) {
        IdOrdersperDay[key] = [];
      }
      IdOrdersperDay[key].push(order);
    });

    const cleanedOrders = [];
    for (const [key, orders] of Object.entries(ordersByPhoneAndDay)) {
      const hasStatus1 = orders.some((order) => order.deleveryStatus === "1");
      if (hasStatus1) {
        cleanedOrders.push(
          ...orders.filter((order) => order.deleveryStatus !== "20")
        );
      } else {
        cleanedOrders.push(...orders);
      }
    }

    const latestOrders = {};
    cleanedOrders.forEach((order) => {
      const date = new Date(order.timeStamp.seconds * 1000).toDateString();
      const key = `${order.phone}-${date}`;

      if (
        !latestOrders[order.phone] ||
        order.timeStamp.seconds > latestOrders[order.phone].timeStamp.seconds
      ) {
        latestOrders[order.phone] = {
          ...order,
          orderCount: countOrdersperDay[key] || 0,
        };
      }
    });

    const filteredOrdersUnique = Object.values(latestOrders).filter(
      (order) => order.deleveryStatus === "20"
    );
    countFiltered = filteredOrdersUnique.length;

    if (filter2 === "0") {
      filteredOrders = filteredOrdersUnique;
      countAll = data.filter((order) => order.deleveryStatus === "20").length;
    } else {
      filteredOrders = data.filter((order) => order.deleveryStatus === "20");
      countAll = filteredOrders.length;
    }

    setOrders(filteredOrders);
    setAllOrders(countAll);
    setAllOrders20(countFiltered);
  }, [data, filter2]);

  const header = (
    <div className="table-header">{t("orders.products_table_title")}</div>
  );
  const total = orders.reduce(
    (sum, order) => sum + Number(order.total || 0),
    0
  );
  const formattedTotal =
    total != null
      ? total.toLocaleString("ar-DZ") + (localizedCurrency ?? "")
      : "--";

  const isRTL = i18n.language === "ar";

  return (
    <div
      className="container-fluid bg-purple-50 min-h-screen dark:!bg-[#141414]"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}

        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-4 m-3 mt-6 border border-purple-100 dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("sidebar.abndndOrders")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-400 mb-0">
                  {t("orders.abandoned_orders_info")}
                </p>
              </div>
            </div>
          </div>

          <div className="mx-3 mb-4 overflow-x-auto pb-2">
            <div className="flex md:grid md:grid-cols-3 gap-3 min-w-max md:min-w-0">
              <div
                onClick={() => setFilter2("1")}
                className={`dark:!bg-[#181919] flex-shrink-0 cursor-pointer w-72 md:w-auto rounded-xl shadow-sm p-4 transition-all duration-200 ${
                  filter2 === "1"
                    ? " bg-[#faf1ff] border-[#9b59bf] border-2 shadow-md"
                    : "dark:!border-[#3c3a3d] bg-white border border-purple-100 hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p
                      className={`mb-1 text-sm ${
                        filter2 === "1"
                          ? "text-[#9e65bb]"
                          : "text-gray-500 dark:!text-gray-300"
                      }`}
                    >
                      {t("orders.all_abandoned_orders")}
                    </p>
                    <h3
                      className={`text-2xl font-bold ${
                        filter2 === "1" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                    >
                      {AllOrders}
                    </h3>
                  </div>
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center ${
                      filter2 === "1" ? "bg-[#efd3ff]" : "bg-[#faf1ff]"
                    }`}
                  >
                    <ShoppingBasket
                      size={24}
                      className={`${
                        filter2 === "1" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                    />
                  </div>
                </div>
              </div>

              <div
                onClick={() => setFilter2("0")}
                className={`dark:!bg-[#181919] flex-shrink-0 cursor-pointer w-72 md:w-auto rounded-xl shadow-sm p-4 transition-all duration-200 ${
                  filter2 === "0"
                    ? "bg-[#faf1ff] border-[#9b59bf] border-2 shadow-md"
                    : "dark:!border-[#3c3a3d] bg-white border border-purple-100 hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p
                      className={`mb-1 text-sm ${
                        filter2 === "0"
                          ? "text-[#9e65bb]"
                          : "text-gray-500 dark:!text-gray-300"
                      }`}
                    >
                      {t("orders.unique_abandoned_orders")}
                    </p>
                    <h3
                      className={`text-2xl font-bold ${
                        filter2 === "0" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                    >
                      {AllOrders20}
                    </h3>
                  </div>
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center ${
                      filter2 === "0" ? "bg-[#efd3ff]" : "bg-[#faf1ff]"
                    }`}
                  >
                    <ShoppingCart
                      size={24}
                      className={`${
                        filter2 === "0" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-shrink-0 w-72 md:w-auto bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-4 border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow transition-all duration-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-gray-500 dark:!text-gray-300 mb-1 text-sm">
                      {t("orders.abandoned_orders_value")}
                    </p>
                    <h3 className="text-2xl font-bold text-[#9e68ba]">
                      {formattedTotal}
                    </h3>
                  </div>
                  <div className="w-12 h-12 rounded-full bg-[#faf1ff] flex items-center justify-center">
                    <Package size={24} className="text-[#9e68ba]" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-4 mx-3 mb-4 border border-purple-100 dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="relative flex-grow max-w-xl  ">
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <Search
                    size={16}
                    className="text-gray-400 dark:!text-gray-300"
                  />
                </div>
                <input
                  type="text"
                  className="bg-gray-50 dark:!bg-[#181919] dark:!text-gray-300 border border-gray-200 dark:!border-[#3c3a3d] text-gray-900 text-sm rounded-lg block w-full pr-10 p-2.5  focus:outline-none focus:ring-2 focus:ring-purple-200"
                  placeholder={t("orders.search_by_order_or_phone")}
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                />
              </div>

              <div className="flex items-center gap-3 self-start">
                <button
                  type="button"
                  onClick={handleRefreshOrders}
                  disabled={isRefreshingOrders || !account?.user}
                  aria-label={t("ui.refreshOrders")}
                  title={t("ui.refreshOrders")}
                  className={`group relative bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-2.5 transition-all duration-200 flex items-center justify-center h-[44px] w-[44px] ${
                    isRefreshingOrders || !account?.user
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:border-[#9b59bf] hover:bg-purple-50 hover:shadow-sm"
                  }`}
                >
                  <RefreshCw
                    size={18}
                    className={`text-[#9b59bf] ${isRefreshingOrders ? "animate-spin" : ""}`}
                  />
                </button>

                <div className="relative">
                  <div
                    onClick={() => setIsPageSizeOpen(!isPageSizeOpen)}
                    className="group relative bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] hover:border-[#9b59bf] text-gray-900 text-sm rounded-lg p-2.5 cursor-pointer min-w-[140px] h-[44px] transition-all duration-200 hover:shadow-sm focus:ring-2 focus:ring-purple-200"
                  >
                    <div className="flex items-center justify-between h-full">
                      <div className="flex items-center gap-2">
                        <div className="w-5 h-5 bg-[#faf1ff] dark:bg-[#181919] rounded-md flex items-center justify-center">
                          <svg
                            className="w-3 h-3 text-[#9b59bf]"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M3 4a1 1 0 000 2h14a1 1 0 100-2H3zM3 10a1 1 0 000 2h14a1 1 0 100-2H3zM3 16a1 1 0 100 2h14a1 1 0 100-2H3z" />
                          </svg>
                        </div>

                        <span className="font-medium text-gray-900 dark:text-gray-300">
                          {pageSizeOptions.find((option) => option.value == pageSize)
                            ?.label || t("orders.ten_orders")}
                        </span>
                      </div>

                      <div
                        className={`transform transition-transform duration-200 ${
                          isPageSizeOpen ? "rotate-180" : ""
                        }`}
                      >
                        <svg
                          className="w-4 h-4 text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="relative">
                    {isPageSizeOpen && (
                      <>
                        <div
                          className="fixed inset-0  bg-opacity-5 z-40 md:hidden"
                          onClick={() => setIsPageSizeOpen(false)}
                        />

                        <div
                          className="absolute mt-1 bg-white dark:!bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg shadow-lg overflow-hidden w-full animate-in slide-in-from-top-1 duration-150"
                          style={{ zIndex: 100000 }}
                        >
                          <div className="bg-[#faf1ff] dark:bg-[#141414] px-4 py-2.5 border-b border-purple-100 dark:!border-[#3c3a3d]">
                            <span className="font-medium text-gray-800 dark:text-gray-300 text-sm">
                              {t("orders.orders_per_page")}
                            </span>
                          </div>

                          <div className="max-h-48 overflow-y-auto">
                            {pageSizeOptions.map((option) => {
                              const isSelected = pageSize == option.value;
                              return (
                                <button
                                  key={option.value}
                                  onClick={() => handlePageSizeSelect(option.value)}
                                  className={`w-full group flex items-center gap-2 px-4 py-2.5 hover:bg-[#faf1ff] cursor-pointer transition-colors duration-150 text-right ${
                                    isSelected
                                      ? "bg-[#faf1ff] dark:!bg-[#2a2b2b] border-r-2 border-[#9b59bf]"
                                      : ""
                                  }`}
                                >
                                  <div className="relative flex-shrink-0">
                                    <div
                                      className={`w-4 h-4 rounded-full border transition-all duration-200 flex items-center justify-center ${
                                        isSelected
                                          ? "bg-[#9b59bf] border-[#9b59bf]"
                                          : "border-gray-300 hover:border-[#9b59bf]"
                                      }`}
                                    >
                                      {isSelected && (
                                        <div className="w-2 h-2 bg-white rounded-full" />
                                      )}
                                    </div>
                                  </div>

                                  <span
                                    className={`text-sm transition-colors ${
                                      isSelected
                                        ? "text-[#9b59bf] font-medium"
                                        : "text-gray-800 dark:text-gray-300 group-hover:text-[#9b59bf]"
                                    }`}
                                  >
                                    {option.label}
                                  </span>
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-3 bg-white rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] mb-6 overflow-hidden">
            {orders.length > 0 ? (
              <DataTableTemplatingDemoAbndn
                filter={filter}
                header={header}
                Allorders={AllOrders}
                Allorders20={AllOrders20}
                orders={orders}
                pageSize={pageSize}
                setFilter2={setFilter2}
              />
            ) : (
              <div className="p-8 text-center dark:!bg-[#181919]">
                <div className="w-16 h-16 mx-auto bg-purple-50  rounded-full flex items-center justify-center mb-4">
                  <ShoppingBag size={32} className="text-[#9e68ba]" />
                </div>
                <h3 className="text-lg font-medium text-gray-800 dark:!text-gray-300 mb-2">
                  {t("orders.no_abandoned_carts")}
                </h3>
                <p className="text-gray-500 dark:!text-gray-400 max-w-md mx-auto">
                  {t("orders.no_abandoned_carts_description")}
                </p>
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default WorkerOrdersabndn;
